import { resetStates } from "../utility/ResetStates";
import { debounce, isScrollable } from "../utility/UtilityFunctions";

export default class PrimaryNavigation {
    constructor(targetElement) {
        // navigation elements
        const element = targetElement || '.c-nav-primary';
        this.elements = {
            html: document.querySelector('html'),
            body: document.querySelector('body'),
            base: document.querySelector(element),
            offcanvas: document.querySelector('.c-offcanvas--menu'),
            menu: document.querySelector(`${element} .menu`),
            subMenu: document.querySelectorAll(`${element} .sub-menu`),
            topLevelMenuItem: document.querySelectorAll(`${element} .menu > .menu-item > a`),
            menuItemsWithChildrenTrigger: document.querySelectorAll(`${element} .menu > .menu-item-has-children > a`),
        };

        // classes
        this.classes = {
            active: 'is-active',
            subMenuActive: 'sub-menu-is-active',
            menuActiveClass: 'navigation-is-active',
            offcanvasBackground: 'c-offcanvas__background-image',
        };

        // Reset triggers
        this.pageWrap = document.querySelector('.s-page-wrap');
        this.menuButton = document.querySelector('.c-menu-button');
        this.bookButton = document.querySelector('.c-page-header__book');

        // Reset Options
        this.resetOptions = {
            // body active state classes
            body: {
                elements: [this.elements.html, this.elements.body],
                classes: `${this.classes.menuActiveClass} ${this.classes.subMenuActive}`,
            },
            // navigation active state classes
            navigation: {
                elements: [this.elements.base, this.elements.menu],
                classes: this.classes.subMenuActive
            },
            // menu items active state classes
            menu__items: {
                elements: [...this.elements.menuItemsWithChildrenTrigger, ...Array.from(this.elements.menuItemsWithChildrenTrigger).map(el => el.parentElement)],
                classes: this.classes.active,
            },
        };

        // wrap sub-menu items in a container
        this.wrapMenuItems();

        // add css variable to tie into reveal animation
        this.elements.subMenu.forEach((subMenu) => {
            subMenu.querySelectorAll('.menu-item').forEach((element, index) => {
                element.style.setProperty('--menu-item-counter', `${index + 2}`);

                if (element.classList.contains('current-menu-item')) {
                    this.setActiveNavItems(element);
                }
            });
        });

        this.bindEventListeners()
        this.checkAndToggleOverflow()
    }

    bindEventListeners() {
        // reveal submenus triggers
        this.elements.menuItemsWithChildrenTrigger.forEach(trigger => {
            trigger.addEventListener('click', (event) => this.revealSubMenus(event));
        });

        // trigger reveal offcanvas on click and toggle resets for active class toggles
        [this.menuButton, this.pageWrap, this.bookButton].forEach(button => {
            button.addEventListener('click', () => {
                document.body.dispatchEvent(new Event('revealOffcanvas'));
                if (this.elements.body.classList.contains(this.classes.menuActiveClass)) return;
                resetStates(this.resetOptions);
            });
        });

        // apply scroll class for scroll indicator visibility
        this.elements.base.onscroll = ({ target }) => {
            this.elements.offcanvas.classList.toggle('menu-scrolled', target.scrollTop > 0);
        }

        // check nav overflow for scroll indicator visibility
        window.addEventListener('resize', debounce((event) => this.checkAndToggleOverflow(event), 500))
    }

    // Function to check and toggle the 'no-overflow' class
    checkAndToggleOverflow(event) {
        if (!isScrollable(this.elements.base)) {
            return this.elements.offcanvas.classList.add('no-overflow');
        }

        this.elements.offcanvas.classList.remove('no-overflow');
    }

    // Set current nav items to active
    // ! Review broken functionality due to resetStates removing this
    setActiveNavItems(target) {
        target.closest('.current-menu-parent').classList.add(this.classes.active);
        target.closest('.current-menu-parent').querySelector('a').classList.add(this.classes.active);
        this.elements.body.classList.add(this.classes.subMenuActive);
    }

    wrapMenuItems() {
        // adds back button to the top of the sub-menu and wraps inner menu items
        this.elements.subMenu.forEach((element) => {
            const menuItems = element.querySelectorAll('.menu-item');
            const container = document.createElement('div');
            container.className = 'sub-menu__container';
            container.setAttribute("role", "list");

            menuItems.forEach((menuItem) => {
                container.appendChild(menuItem);
            });

            element.prepend(container);
        });
    }

    revealSubMenus(event) {
        event.preventDefault();

        const target = event.target;
        // removes all menu__item / > a active classes
        this.elements.menuItemsWithChildrenTrigger.forEach(trigger => {
            if (trigger !== target) {
                trigger.classList.remove(this.classes.active);
                trigger.parentElement.classList.remove(this.classes.active);
            }
        });

        // toggles clicked target's active class
        target.classList.toggle(this.classes.active);
        target.parentElement.classList.toggle(this.classes.active);

        // adds or removes sub-menu active class
        if (target.classList.contains(this.classes.active)) {
            this.elements.base.classList.add(this.classes.subMenuActive);
            this.elements.menu.classList.add(this.classes.subMenuActive);
            this.elements.body.classList.add(this.classes.subMenuActive);

        } else {
            this.elements.base.classList.remove(this.classes.subMenuActive);
            this.elements.menu.classList.remove(this.classes.subMenuActive);
            this.elements.body.classList.remove(this.classes.subMenuActive);
        }

        // recheck for overflow
        setTimeout(() => {
            this.checkAndToggleOverflow();
        }, 250);
    }
}
